import React, {PropTypes} from 'react';

import styled from 'styled-components';

const GriddleTotalResults = styled.div`
  display: inline-block;
  color: ${props => props.theme.color.base3};
  line-height: 40px;
`;

const TotalResults = ({ currentPage, limit, total, pageCount }) => {
  return (
    <GriddleTotalResults>
      {total > limit &&
        <div>
          {
            `Showing ${currentPage * limit + 1} - ${(currentPage * limit + pageCount) } of ${total.toLocaleString('en-AU')} results`
          }
        </div>}
    </GriddleTotalResults>
  );
};

TotalResults.propTypes = {
  currentPage: PropTypes.number,
  limit: PropTypes.number,
  total: PropTypes.number,
  pageCount: PropTypes.number
};

export default TotalResults;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/TotalResults.js